<template>
  <div class="">

    <div v-if="!pgLoading" id="about-area" class="about-area pt-100 pb-70">
      <div class="container">

        <!-- <div id="about-content" class="row align-items-center" v-for="(item, idx) in items" :key="idx"> -->
        <div id="about-content" class="row align-items-center">

          <div class="col-lg-6">
            <div class="about-content">
              <div class="section-title">
                <h2>{{ ($i18n.locale == 'en') ? items.en.title : items.ar.title }}</h2>
              </div>
              <p v-html="($i18n.locale == 'en') ? items.en.body : items.ar.body"></p>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="about-img">
              <img v-if="items.image" :src="items.image" :alt="items.en.title">
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'WhoWeAre',
  components: {
    //
  },
  data() {
    return {
      //
      items: null,
      pgLoading: true,
      refs: 'pages'
    }
  },
  mounted() {

  },
  created() {
    //
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/' + this.refs,
        method: 'GET',
        data: {},
        headers: {
          appId: process.env.VUE_APP_APPID
        },
      }
      this.axios(options)
        .then(res => {
          this.pgLoading = false;
          const result = res.data.data.rows.find((row) => { return row.title === 'Who We Are' });

          this.items = result;
          // this.items = res.data.data.rows;
        })
        .catch(() => {
          this.pgLoading = false;
        })
        .finally(() => {
          this.pgLoading = false;
          if (localStorage.getItem('locale') == 'ar') {
            document.getElementById("about-content").classList.add('is-rtl');
          }
        });
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
